import { useEffect, useRef, useState } from 'react';
import useKeypress from 'react-use-keypress';

export function useScannerInput({ onBarcodeComplete, onNfcComplete, inputHasFocus, onFocused, showEbarimtModal }) {
    const nfcCodeRef = useRef('');
    const barcodeTextRef = useRef('');

    const onNfcCompleteRef = useRef(onNfcComplete);
    const onBarcodeCompleteRef = useRef(onBarcodeComplete);
    useEffect(() => { onNfcCompleteRef.current = onNfcComplete; }, [onNfcComplete]);
    useEffect(() => { onBarcodeCompleteRef.current = onBarcodeComplete; }, [onBarcodeComplete]);

    const [barCodeListening, setBarCodeListening] = useState(false);
    const [nfcListening, setNfcListening] = useState(false);

    useKeypress(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Enter'], (event) => {
        if (onFocused || inputHasFocus || showEbarimtModal) {
            return;
        }

        if (nfcListening) {
            if (event.key?.toLowerCase() === 'enter') {
                const code = nfcCodeRef.current;
                nfcCodeRef.current = '';
                onNfcCompleteRef.current(code);
            } else {
                nfcCodeRef.current = nfcCodeRef.current + event?.key;
            }
        } else if (barCodeListening) {
            if (event.key?.toLowerCase() === 'enter') {
                const code = barcodeTextRef.current;
                barcodeTextRef.current = '';
                onBarcodeCompleteRef.current(code);
            } else {
                barcodeTextRef.current = barcodeTextRef.current + event?.key;
            }
        }
    });

    return { barCodeListening, setBarCodeListening, nfcListening, setNfcListening };
}
